'use strict';

window._etmc = window._etmc || [];
module.exports = {
  collectjs: {
    // set user info whenever a user get's a contact id
    // either authentication or email sign up
    // it appears the main reason for the localStorage usage is so the emailSignup functionality in the footer
    // isn't used to create multiple emails
    setUserInfo: function setUserInfo(updateContactId) {
      if (updateContactId) {
        module.exports.data.contactId = updateContactId;
      }
      if (!module.exports.data.contactId) {
        module.exports.data.contactId = window.localStorage.getItem('vfwContactId');
      }
      if (module.exports.data.contactId) {
        _etmc.push(['setUserInfo', {
          'email': module.exports.data.contactId
        }]);
        _etmc.push(['trackPageView']);
      }
    },
    // send cart data anytime the cart changes
    trackCart: function trackCart() {
      if (module.exports.data.cartItemsUrl) {
        $.ajax({
          url: module.exports.data.cartItemsUrl,
          method: 'GET',
          dataType: 'json',
          success: function success(data) {
            if (data.items && data.items.length > 0) {
              _etmc.push(["trackCart", {
                "cart": data.items
              }]);
            } else if (data.items && data.items.length === 0) {
              _etmc.push(["trackCart", {
                "clear_cart": true
              }]);
            }
          },
          error: function error(err) {
            console.error(err);
          }
        });
      }
    }
  }
};
Object.defineProperties(module.exports, {
  data: {
    enumerable: true,
    get: function get() {
      var _window$CachedData, _window$UncachedData;
      return Object.assign({}, ((_window$CachedData = window.CachedData) === null || _window$CachedData === void 0 ? void 0 : _window$CachedData.mcloud) || {}, ((_window$UncachedData = window.UncachedData) === null || _window$UncachedData === void 0 ? void 0 : _window$UncachedData.mcloud) || {});
    },
    writeable: true
  },
  mcEnabled: {
    enumerable: true,
    get: function get() {
      var _module$exports$data;
      return !!((_module$exports$data = module.exports.data) !== null && _module$exports$data !== void 0 && _module$exports$data.mcEnabled);
    }
  }
});